import React from 'react';
import { useSelector } from 'react-redux';
import logo from '../assets/logo.png';

const Loading = ({ message = 'Loading...' }) => {
  const { theme } = useSelector((state) => state.theme);

  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] h-full w-full py-12">
      <div className="relative flex items-center justify-center">
        {/* Animated Background Glow */}
        <div className={`absolute w-32 h-32 rounded-full blur-2xl opacity-20 animate-pulse-fast ${
          theme === 'dark' ? 'bg-indigo-400' : 'bg-indigo-600'
        }`}></div>

        {/* Main outer ring */}
        <div className="w-24 h-24 border-4 border-indigo-100/30 border-t-indigo-600 rounded-full animate-spin shadow-lg"></div>
        
        {/* Middle ring rotating opposite */}
        <div className="absolute w-20 h-20 border-4 border-transparent border-t-indigo-400 rounded-full animate-spin-reverse opacity-80"></div>

        {/* Inner ring */}
        <div className="absolute w-16 h-16 border-4 border-transparent border-b-indigo-300 rounded-full animate-spin-slow opacity-60"></div>
        
        {/* App Icon in the center */}
        <div className="absolute flex items-center justify-center animate-float">
          <img 
            src={logo} 
            alt="App Icon" 
            className="w-10 h-10 object-contain drop-shadow-md animate-pulse-fast" 
          />
        </div>
      </div>
      
      {message && (
        <div className="mt-8 flex flex-col items-center animate-bounce-slow">
          <p className={`text-xl font-bold tracking-widest uppercase italic ${
            theme === 'dark' ? 'text-indigo-300' : 'text-indigo-600'
          }`}>
            {message}
          </p>
          <div className="flex space-x-2 mt-3">
            <div className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce [animation-delay:-0.3s] shadow-sm"></div>
            <div className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce [animation-delay:-0.15s] shadow-sm"></div>
            <div className="w-2 h-2 bg-indigo-500 rounded-full animate-bounce shadow-sm"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Loading;
